import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ScrollSectionContainer = styled.section`
  width: 100%;
  height: 650px;
  display: flex;
  background: #fff;
`;

const TextSection = styled.div`
  flex: 1.83;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 80px 60px;
  background: white;
`;

const ImageSection = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
`;

const ScrollImage = styled.div<{ $bgImage: string; $isActive: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${props => props.$bgImage}) center/cover;
  opacity: ${props => props.$isActive ? 1 : 0};
  transition: opacity 1s ease-in-out;
`;

const MainTitle = styled.h2`
  font-size: 3.5rem;
  font-weight: 300;
  color: #333;
  margin-bottom: 20px;
  letter-spacing: 3px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 400;
  color: #2c2c2c;
  margin-bottom: 30px;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.8;
  max-width: 500px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const DateText = styled.div`
  font-size: 1rem;
  color: #333;
  font-weight: 500;
  letter-spacing: 1px;
`;

const ScrollSection: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    'https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1520854221256-17451cc331bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  ];

  useEffect(() => {
    const handleScroll = () => {
      const newScrollY = window.scrollY;
      
      // Scroll pozisyonuna göre resim değiştir
      const scrollThreshold = 500; // Her 500px scroll'da resim değişir
      const newImageIndex = Math.floor(newScrollY / scrollThreshold) % images.length;
      setCurrentImageIndex(newImageIndex);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [images.length]);

  return (
    <ScrollSectionContainer>
      <TextSection>
        <MainTitle>SARAYLI MODA</MainTitle>
        <Subtitle>Zarafetin Adresi</Subtitle>
        <Description>
          2008'den bugüne uzanan zarafetin mirasını taşıyan Saraylı Moda, 
          gelinlik tasarımında kaliteyi, özgünlüğü ve kusursuzluğu bir araya getiriyor.
        </Description>
        <DateText>2008 - 2026</DateText>
      </TextSection>

      <ImageSection>
        {images.map((image, index) => (
          <ScrollImage
            key={index}
            $bgImage={image}
            $isActive={index === currentImageIndex}
          />
        ))}
      </ImageSection>
    </ScrollSectionContainer>
  );
};

export default ScrollSection;
